import Cricket from "components/cricket"
import GreyHoundRacingInplay from "components/greyHoundRacingInplay"
import HorseRacingInPlay from "components/horseRacingInplay"
import Soccer from "components/soccer"
import Tennis from "components/tennis"
import { useEffect } from "react"
import { useDispatch, useSelector } from "react-redux"
import { fetchSportsEvents } from '../../redux/slice/events/eventsSlice'
import { fetchAllOpenBets } from '../../redux/slice/openBets/openBetsSlice'

const Inplay = () => {
    const dispatch = useDispatch();
    const { cricketLiveEvents, soccerLiveEvents, tennisLiveEvents, loading, events } = useSelector((state) => state.events);
    const { userdata, isAuthenticated } = useSelector((state) => state.authSlice);
    const { openBets, loading: openBetsLoading, error: openBetsError } = useSelector((state) => state.openBets);
    useEffect(() => {
        if (isAuthenticated) {
            dispatch(fetchSportsEvents());
            dispatch(fetchAllOpenBets());
        }
    }, [isAuthenticated, dispatch]);

    return (
        <div className='relative min-w-full'>
            <div className='grid grid-cols-12'>
                <div className='col-span-12'>
                    <div className='relative w-full'>
                        <p className='bg-[#18adc5] text-[#fff] text-[14px] font-bold h-[28px] leading-[19px] m-0 pl-[7px] pr-[10px] py-[6px] capitalize'>In-Play</p>
                    </div>
                    {/* <div className="bg-[#fff] text-[#000] !mb-0">
                        <div className="leading-none">
                            <ul className="flex items-baseline pt-[5px] pr-[10px] pb-[0] pl-[5px] m-0 overflow-auto">
                                <li className="text-center w-auto inline-block px-[10px] lg:px-[17px] py-[0]">
                                    <a href="#" className="text-[#000] relative">
                                        <img className="w-[55px] lg:ml-[4px] mb-[2px]" src="/assets/images/inplay.png" />
                                        <span className="block text-[14px] font-bold leading-[26px] mx-[auto] my-[0] max-w-[90px] overflow-hidden overflow-ellipsis whitespace-nowrap">Watch Live</span>
                                    </a>
                                </li>
                                <li className="text-center w-auto inline-block px-[10px] lg:px-[17px] py-[0]">
                                    <a href="#" className="text-[#000] relative">
                                        <img className="w-[55px]  mb-[2px]" src="/assets/images/all-sports.png" />
                                        <span className="block text-[14px] font-bold leading-[26px] mx-[auto] my-[0] max-w-[90px] overflow-hidden overflow-ellipsis whitespace-nowrap">All Games</span>
                                    </a>
                                </li>
                                <li className="text-center w-auto inline-block px-[10px] lg:px-[17px] py-[0]">
                                    <a href="#" className="text-[#000] relative">
                                        <span className="in-play-budge">4</span>
                                        <img className="w-[55px]  mb-[4px]" src="/assets/images/cricket.png" />
                                        <span className="block text-[14px] font-bold leading-[26px] mx-[auto] my-[0] max-w-[90px] overflow-hidden overflow-ellipsis whitespace-nowrap">Cricket</span>
                                    </a>
                                </li>
                                <li className="text-center w-auto inline-block px-[10px] lg:px-[17px] py-[0]">
                                    <a href="#" className="text-[#000] relative">
                                        <span className="in-play-budge">1</span>
                                        <img className="w-[55px]  mb-[4px]" src="/assets/images/soccer.png" />
                                        <span className="block text-[14px] font-bold leading-[26px] mx-[auto] my-[0] max-w-[90px] overflow-hidden overflow-ellipsis whitespace-nowrap">Soccer</span>
                                    </a>
                                </li>
                                <li className="text-center w-auto inline-block px-[10px] lg:px-[17px] py-[0]">
                                    <a href="#" className="text-[#000] relative">
                                        <span className="in-play-budge">1</span>
                                        <img className="w-[55px]  mb-[4px]" src="/assets/images/tennis.png" />
                                        <span className="block text-[14px] font-bold leading-[26px] mx-[auto] my-[0] max-w-[90px] overflow-hidden overflow-ellipsis whitespace-nowrap">Tennis</span>
                                    </a>
                                </li>
                                <li className="text-center w-auto inline-block px-[10px] lg:px-[17px] py-[0]">
                                    <a href="#" className="text-[#000] relative">
                                        <span className="in-play-budge">1</span>
                                        <img className="w-[55px]  mb-[4px]" src="/assets/images/horse.png" />
                                        <span className="block text-[14px] font-bold leading-[26px] mx-[auto] my-[0] max-w-[90px] overflow-hidden overflow-ellipsis whitespace-nowrap">Horse</span>
                                    </a>
                                </li>
                                <li className="text-center w-auto inline-block px-[10px] lg:px-[17px] py-[0]">
                                    <a href="#" className="text-[#000] relative">
                                        <span className="in-play-budge">1</span>
                                        <img className="w-[55px]  mb-[4px]" src="/assets/images/greyhound.png" />
                                        <span className="block text-[14px] font-bold leading-[26px] mx-[auto] my-[0] max-w-[90px] overflow-hidden overflow-ellipsis whitespace-nowrap">GreyHound</span>
                                    </a>
                                </li>
                            </ul>
                        </div>
                    </div> */}
                </div>

                <div className='col-span-12 '>
                    <Cricket events={cricketLiveEvents} />
                </div>

                <div className='col-span-12 '>
                    <Soccer events={soccerLiveEvents} />
                </div>

                <div className='col-span-12 '>
                    <Tennis events={tennisLiveEvents} />
                </div>

                {/* <div className='col-span-12 '>
                    <HorseRacingInPlay />
                </div> */}

                {/* <div className='col-span-12 '>
                    <GreyHoundRacingInplay />
                </div> */}

                <div className="col-span-12 block lg:hidden">
                    <div className='bg-[linear-gradient(#5ecbdd,_#146578)] text-[#fff] text-[12px] h-[23px] m-0 px-[4px] py-[0] uppercase'>
                        <p className='text-[#fff] text-[12px] p-[2px] capitalize'>Matched Bet</p>
                    </div>
                    <div className="!bg-[#fff] block overflow-x-auto w-full">
                        <table className="w-full whitespace-nowrap !mb-6 text-[#212529]">
                            <thead className=''>
                                <tr className="!bg-[#028dad] !text-[#ffffff]">
                                    <th className='px-[3px] py-px border-[#fff] border-[1px] align-bottom border-b-[#dee2e6]  border-b-[2px] '>Matched Bet</th>
                                    <th className='px-[3px] py-px border-[#fff] border-[1px] align-bottom border-b-[#dee2e6]  border-b-[2px] '>Odds</th>
                                    <th className='px-[3px] py-px border-[#fff] border-[1px] align-bottom border-b-[#dee2e6]  border-b-[2px] '>Stake</th>
                                </tr>
                            </thead>
                            <tbody>
                                {
                                    openBets?.length > 0 ?
                                        openBets?.map((item, index) => (
                                            <tr key={index} className={item?.is_back ? "bg-[#72bbef]" : "bg-[#faa9ba]"}>
                                                <th className='px-[3px] py-px border-[#dee2e6] border-[1px] align-bottom border-b-[#dee2e6]  border-b-[2px] '>{item?.runner_name}</th>
                                                <th className='px-[3px] py-px border-[#dee2e6] border-[1px] align-bottom border-b-[#dee2e6]  border-b-[2px] '>{item?.price_val}</th>
                                                <th className='px-[3px] py-px border-[#dee2e6] border-[1px] align-bottom border-b-[#dee2e6]  border-b-[2px] '>{item?.stake}</th>
                                            </tr>
                                        ))
                                        :
                                        <tr>
                                            <td className="px-[3px] py-px border-[1px] border-[solid] border-[#dee2e6]  !text-[#c7313f] !text-center" colSpan="3">No bets found...</td>
                                        </tr>
                                }
                            </tbody>
                        </table>

                    </div>
                </div>
            </div>
        </div>
    )
}
export default Inplay